import { Component, Input } from '@angular/core';
import { EIcons } from '@passer-technologies/components';

@Component({
  selector: 'app-simple-info',
  templateUrl: './simple-info.component.html',
  styleUrls: ['./simple-info.component.scss'],
  standalone: false
})
export class SimpleInfoComponent {
  @Input() classDiv = '';
  @Input() iconColor = 'purple';
  @Input() iconSize = 'w-10px h-10px';
  @Input() srcIcon: EIcons = EIcons.circle;
  @Input() info;
}
